import { render, staticRenderFns } from "./welcome-screen-light.vue?vue&type=template&id=521d0268"
import script from "./welcome-screen-light.vue?vue&type=script&lang=js"
export * from "./welcome-screen-light.vue?vue&type=script&lang=js"
import style0 from "./welcome-screen-light.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports